import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { toast } from "sonner";

export function QrScanner({ active, elementId, onDecoded, onClose }) {
  const onDecodedRef = useRef(onDecoded);
  const onCloseRef = useRef(onClose);
  onDecodedRef.current = onDecoded;
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!active) return;
    const scanner = new Html5Qrcode(elementId);
    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: 250 }, (decoded) => {
        scanner.stop().catch(() => {});
        onCloseRef.current?.();
        onDecodedRef.current?.(decoded);
      }, () => {})
      .catch(() => {
        toast.error("Impossibile accedere alla fotocamera");
        onCloseRef.current?.();
      });
    return () => {
      scanner.stop().catch(() => {});
    };
  }, [active, elementId]);

  if (!active) return null;
  return <div id={elementId} className="w-full rounded-xl overflow-hidden" />;
}
